import { useEffect } from 'react';
import { message } from 'antd';
import { FiLogOut } from "react-icons/fi";
import { authService } from '../../auth/auth-service';

const Logout = () => {
	const handleLogout = () => { authService.logout(); };

	useEffect(() => {
		handleLogout();
	}, []);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				fontSize: "20px",
				color: "#042A4A",
				gap: "10px",
			}}
		>
			<FiLogOut size={50} color="#042A4A" />
			Logging out...
		</div>
	);
};

export default Logout;
